import { BrowserRouter, Route, Routes } from "react-router";
import './App.css';
import Main from "./pages/Main";
import About from "./pages/About";
import Alquiler from "./pages/Alquiler";
import Venta from "./pages/Venta";
import Propiedad from "./pages/Propiedad";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Propiedades from "./pages/Propiedades";
function App() {
  return (
    <BrowserRouter>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '125dvh' }}>
        <Header />
        
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Main />} exact />
            <Route path="/alquiler" element={<Alquiler />} exact />
            <Route path="/about" element={<About />} exact />
            <Route path="/ventas" element={<Venta />} exact />
            <Route path="/propiedad/:id" element={<Propiedad />} exact />
            <Route path="/propiedades" element={<Propiedades />} exact />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;